<template>

            <div class="np-group np-pt-3">
                <div class="np-header1 np-pb-4">Логи</div>
            </div>
            <div class="np-grid np-pt-3 np-flex-1">
                <div class="np-col np-col-12">
                    <div class="np-panel np-flex-1">
                        <PerfectScrollbar>
                            <div class="np-table">
                                <div class="np-table-header">                                    
                                    <div class="np-table-row">
                                        <div class="np-table-header-cell">
                                            <button class="np-btn np-btn-primary np-p-custom-0 np-mr-2">
                                                <svg><use href="@/assets/images/icons/sertificate.svg#icon"></use></svg>
                                            </button>
                                        </div>                                        
                                        <div class="np-table-header-cell">
                                            <vSelect placeholder="Дата действия" :options="[
                                                'Редизайн',
                                                'Оптимизация бэкенда (Исполнитель Иванов ИВан Иванович)',
                                                'Подготовить презентацию для к показу'
                                            ]" />
                                        </div>
                                        <div class="np-table-header-cell">
                                            <select class="np-select"><option>Действие</option></select>
                                        </div>  
                                        <div class="np-table-header-cell">
                                            <select class="np-select"><option>Пользователь</option></select>
                                        </div>  
                                        <div class="np-table-header-cell">
                                            <select class="np-select"><option>Проект</option></select>
                                        </div>                                      
                                        <div class="np-table-header-cell">
                                            <select class="np-select"><option>Задача</option></select>
                                        </div>                                      
                                        <div class="np-table-header-cell">
                                            <select class="np-select"><option>Статус</option></select>
                                        </div>                                                                   
                                    </div>
                                </div>
                                <div class="np-table-body">
                                    <div class="np-table-row">
                                        <div class="np-table-cell">1</div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                        <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    </div>
                                    <div class="np-table-row">
                                        <div class="np-table-cell">2</div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell">Оптимизация бэкенда (Исполнитель Иванов ИВан Иванович)</div>
                                        <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                        <div class="np-table-cell"><span class="np-badge np-danger">Активно</span></div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    </div>
                                    <div class="np-table-row">
                                        <div class="np-table-cell">2</div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell">Подготовить презентацию для к показу</div>
                                        <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                        <div class="np-table-cell"><span class="np-badge np-success">Активно</span></div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    </div>
                                    <div class="np-table-row">
                                        <div class="np-table-cell">3</div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell">Написать отчет по продажам</div>
                                        <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                        <div class="np-table-cell"><span class="np-badge np-freeze">Активно</span></div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    </div>
                                    <div class="np-table-row">
                                        <div class="np-table-cell">4</div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell">Проверить контент для соцсетей</div>
                                        <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    </div>
                                    <div class="np-table-row">
                                        <div class="np-table-cell">11</div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell">Утвердить план проекта</div>
                                        <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    </div>
                                    <div class="np-table-row">
                                        <div class="np-table-cell">12</div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                        <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                        <div class="np-table-cell">31.04.2025</div>
                                        <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    </div>                                    
                                </div>                                                                                    
                            </div>
                        </PerfectScrollbar>
                    </div>                                                    
                </div>
            </div>

</template>

<script>

import Accordion from '@/components/elements/Accordion.vue'
import Config from '../../config'

export default {
    components: {
        Accordion
    },
    data() {
        return {
            Config,
            compInfo: null,
        }
    },
    beforeMount: function () {
        //this.getListComp()
    },
    computed: {
              
    },
    methods: {
   
    }

}
</script>

<style>
    .home {
        width: 100%;
        height: 100%;
    }
    .shelf {
        flex: 1 1 auto;
        width: 100%;
        margin-bottom: 10px;
        border: none;
        background-color: transparent;
        display: flex;
        flex-direction: row;
        font-size: 13px;
    }
    .shelf:last-child {
        margin-bottom: 0;
    }
    .labelbox {
        flex: 0 0 70%;
    }
    .valuebox {
        flex: 0 0 10%;
    }
    .valuebox img {
        width: 24px;
        opacity: .8;
    }
    .command-user__list-title.shelf {
        font-size: 14px;
        font-weight: 500;
    }
    .stats-select-date {
        padding: 10px 20px;
        font-size: 12px;
        background-color: #FFF;
        border: 10px;
        border-width: 0;
        box-shadow: 0 3px 5px rgb(0 0 0 / 4%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>